import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarOrgaoRequest } from './types';

// ACTIONS
import { atualizarOrgaoSuccess, atualizarOrgaoFailure } from './actions';

function* atualizarOrgao(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: AtualizarOrgaoRequest } =
		request;

	const body = { ...payload };

	delete body.id;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`orgaos/${payload.id}`,
		body,
	);

	if (response.status === 200) {
		yield put(atualizarOrgaoSuccess(response));
	} else {
		yield put(atualizarOrgaoFailure());
	}
}

export default all([takeLatest(Types.ATUALIZAR_ORGAO, atualizarOrgao)]);
